import type { ReactNode } from 'react'
import Sidebar from './Sidebar'
import TopBar from './TopBar'
import { useUIStore } from '../stores/ui'

export default function Layout({ children }: { children: ReactNode }) {
  const sidebarOpen = useUIStore((s) => s.sidebarOpen)

  // モバイル(lg未満): margin無し（サイドバーはオーバーレイ）
  // デスクトップ(lg以上): sidebarOpen で 224px or 56px
  return (
    <div className="min-h-screen bg-cream">
      <Sidebar />
      <div
        className={`transition-all duration-200 flex flex-col min-h-screen ${
          sidebarOpen ? 'lg:ml-56' : 'lg:ml-14'
        }`}
      >
        <TopBar />
        <div className="flex-1">{children}</div>
      </div>
    </div>
  )
}
